import { render, staticRenderFns } from "./item-layout.vue?vue&type=template&id=a8798338"
import script from "./item-layout.vue?vue&type=script&lang=ts"
export * from "./item-layout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports